import { useCustomMediaQuery, useMediaQuery } from 'academy-common-lib/utils/Styling';
import HomePageSection from '../../../components/Layouts/HomePageSection';
import UsageTracker from '../../../utils/UsageTracker';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Box } from 'foundations-components/transitional/components/Box';
import { View } from 'foundations-components/components/View';
import { H4 } from 'foundations-components/transitional/components/H4';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import RouterButton from 'ui-addon-react-router-dom/RouterButton';
import { getSearchUrl } from '../../search/searchRouting';
import { RankedRecommendationsWithNegativeFeedback } from './RankedRecommendationsWithNegativeFeedback';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { useAnnouncements } from '../../announcements/hooks/AnnouncementsSectionHooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ViewMoreCTA = ({
  marginBlockStart
}) => {
  return /*#__PURE__*/_jsx(RouterButton, {
    marginBlockStart: marginBlockStart,
    to: getSearchUrl({
      contentType: 'SHORT_FORM_CONTENT'
    }),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.growRecommendations.viewMoreCta"
    })
  });
};
export const GrowHomepageRecommendationsSection = () => {
  const {
    isTablet
  } = useMediaQuery();
  const {
    announcements
  } = useAnnouncements();
  const isCompactView = useCustomMediaQuery('(max-width: 1300px)');
  let cardSize = 'medium';
  const hasAnnouncements = announcements === null || announcements === void 0 ? void 0 : announcements.length;
  if (isTablet) {
    cardSize = 'small';
  } else if (!isCompactView) {
    cardSize = 'large';
  }
  const handleOnItemClick = ({
    id,
    type,
    language,
    name
  }, index) => {
    UsageTracker.trackStandalone('Learning Center Interaction', {
      action: 'grow-recommendation-card-click',
      cardNumber: index + 1,
      contentId: id,
      contentType: type,
      name,
      language: language,
      recommendationType: 'ranked'
    });
  };
  const renderRecommendationsContentBody = () => /*#__PURE__*/_jsxs(TFlex, {
    direction: isTablet ? 'column' : undefined,
    gap: isCompactView ? 24 : 90,
    wrap: "wrap",
    children: [/*#__PURE__*/_jsxs(Box, {
      flex: 1,
      children: [/*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.growRecommendations.header"
        })
      }), /*#__PURE__*/_jsx(Paragraph, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.growRecommendations.subheader"
        })
      }), /*#__PURE__*/_jsxs(List, {
        styled: true,
        children: [/*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.growRecommendations.line1"
          })
        }), /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.growRecommendations.line2"
          })
        })]
      }), !isTablet && /*#__PURE__*/_jsx(ViewMoreCTA, {
        marginBlockStart: "600"
      })]
    }), /*#__PURE__*/_jsx(Box, {
      flex: 1,
      inlineSize: "100%",
      children: /*#__PURE__*/_jsx(View, {
        minBlockSize: "300px",
        children: /*#__PURE__*/_jsx(RankedRecommendationsWithNegativeFeedback, {
          appearsIn: "grow-homepage-recommendations",
          direction: isCompactView ? 'column' : 'row',
          errorMarker: "HOMEPAGE_FEATURED_SECTION_ERROR",
          flush: true,
          inferenceSource: "GROW_HOMEPAGE_RECOMMENDATIONS",
          navMarker: "HOMEPAGE_FEATURED_SECTION_LOADED",
          onItemClick: handleOnItemClick,
          resultTypes: ['SHORT_FORM_CONTENT'],
          size: cardSize
        })
      })
    }), isTablet && /*#__PURE__*/_jsx(ViewMoreCTA, {
      marginBlockStart: "200"
    })]
  });
  return /*#__PURE__*/_jsx(HomePageSection, {
    "data-test-id": "grow-homepage-recommendations",
    paddingBlock: "0",
    children: !hasAnnouncements ? /*#__PURE__*/_jsx(CardWrapper, {
      "data-test-id": "grow-recommendations-card-wrapper",
      marginBlockEnd: "0",
      padding: "1000",
      children: renderRecommendationsContentBody()
    }) : renderRecommendationsContentBody()
  });
};